import { ClientOrg, Hymnal } from '../../../common/src/model.ts';
import { Pages } from '../../../common/src/pages.ts';
import { isOrgPrimaryHymnal } from '../data/hymnals.ts';
import { FavoritesHymnalId } from '../data/use_hymnals.tsx';
import { PrimaryOrgHymnalId } from '../util/path.ts';

// Whether a tap on a song row opens the player once decideSongClickGate has let it through: a
// household without subscription-like access still gets the music its organization gives it -
// the weekly song lists, Our Hymnal, Favorites, and the organization's primary hymnals. With one
// primary hymnal its songs are copied into Our Hymnal; with two or more each is its own tile on
// the Our Hymnal page, and the songs inside must open the same way (issue #3728). The Library
// stays the upsell surface: there a primary hymnal's songs are gated and its tile is dimmed
export function isSongClickEnabled({
  page,
  hymnal,
  hymnals,
  org,
  hasPaidContentAccess,
  isShowingWeeklySongLists,
  searchString,
}: {
  page: Pages | undefined;
  hymnal: Hymnal | undefined;
  hymnals: Hymnal[];
  org: Pick<ClientOrg, 'primaryHymnalIds'> | undefined;
  hasPaidContentAccess: boolean;
  isShowingWeeklySongLists: boolean;
  searchString: string;
}): boolean {
  if (hasPaidContentAccess) {
    return true;
  }
  if (isShowingWeeklySongLists && !searchString) {
    return true;
  }
  if (!hymnal) {
    return false;
  }
  if (hymnal.id === PrimaryOrgHymnalId || hymnal.id === FavoritesHymnalId) {
    return true;
  }
  return page !== Pages.Library && isOrgPrimaryHymnal(hymnals, hymnal, org);
}
